import trialSettings from '../trialSettings';
import tableSettings from '../dataTableSettings';

export default (uiID) => {
  const headerIds = Array.isArray(uiID) ? uiID : trialSettings.tabs[uiID].headers;
  let settings = {}
  let matchedHeaders = [];
  headerIds.forEach(key => {
    settings[key] = tableSettings.headers[key];
  })
  // matchedHeaders.forEach(key => settings[key] = tableSettings.headers[key])

  return settings;
}
